import { ErrorBoundary } from 'react-error-boundary';
import { NavigationCustomizationItemDto } from '@asset-metrix/portal-gateway-client-js';
import { Page, PageProps } from '@asset-metrix/portal-ui';
import * as Sentry from '@sentry/react';

import { PageErrorFallback } from './PageErrorFallback';

type PageWithErrorBoundaryProps = PageProps & {
  activeDynamicNavigationItem?: NavigationCustomizationItemDto;
  slug?: string;
};

export function PageWithErrorBoundary({
  activeDynamicNavigationItem,
  slug,
  ...pageProps
}: PageWithErrorBoundaryProps) {
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => (
        <PageErrorFallback
          activeDynamicNavigationItem={activeDynamicNavigationItem}
          error={error}
          slug={slug}
        />
      )}
      onError={(error) => {
        Sentry.captureException(error);
      }}
    >
      <Page {...pageProps} />
    </ErrorBoundary>
  );
}
